export const ROUTES = {
  HOME: "/",
  SIGN_IN: "/sign/in",
  DAILY: "/daily",
  WEEKLY: "/weekly",
  SPRINTS: "/sprints",
  ACTIVE_SPRINT: "/sprints/:sprintId",
  STANDARDS: "/standards",
};
